module.exports = __webpack_public_path__ + "img/temperature.c451d3df.svg";